import { PurplePlus, Remove } from '#assets/svg';
import { useDashboardCharFormExerciseState } from '#pages/DashboardChartForm/states/dashboardCharFormExerciseState';
import { useExercisePresetRecoil } from '#states/exercisePresetsState';
import { IExercisePresetWorkoutSet } from '#types/exercisePresets';
import { produce } from 'immer';
import { useLocation } from 'react-router';

interface ExerciseSetProps {
  index: number;
  sets: IExercisePresetWorkoutSet[];
}
export const ExerciseSet = ({ index, sets }: ExerciseSetProps) => {
  const { setExercisePresets } = useExercisePresetRecoil();

  const { setRecords } = useDashboardCharFormExerciseState();

  const { pathname } = useLocation();
  const isSelectPresetPage = pathname.includes('/select-presets');

  // 세트 추가
  const onAddSet = () => {
    if (isSelectPresetPage) {
      setExercisePresets(
        produce(draft => {
          draft.exercisePresetWorkout[index].sets.push({
            setType: draft.exercisePresetWorkout[index].sets[0].setType,
            round: draft.exercisePresetWorkout[index].sets.length + 1
          });
        })
      );
    } else {
      setRecords(
        produce(draft => {
          draft[index].sets.push({
            setType: draft[index].sets[0].setType,
            round: draft[index].sets.length + 1
          });
        })
      );
    }
  };

  // 세트 삭제
  const onRemoveSet = () => {
    if (isSelectPresetPage) {
      setExercisePresets(
        produce(draft => {
          draft.exercisePresetWorkout[index].sets.pop();
        })
      );
    } else {
      setRecords(
        produce(draft => {
          draft[index].sets.pop();
        })
      );
    }
  };

  if (!sets) return null;

  return (
    <div className="flex justify-between gap-8">
      <div
        onClick={() => {
          if (sets.length === 1) return;
          onRemoveSet();
        }}
        className="w-full px-10 py-4 rounded-lg border-1 border-solid border-[#9170f2] flex justify-center items-center gap-4 text-[#7750e9] text-sm font-medium font-[Pretendard Variable] leading-snug"
      >
        <Remove />
        <div>세트 삭제</div>
      </div>
      <div
        onClick={onAddSet}
        className="w-full px-10 py-4 rounded-lg border-1 border-solid border-[#9170f2] flex justify-center items-center gap-4 text-[#7750e9] text-sm font-medium font-[Pretendard Variable] leading-snug"
      >
        <PurplePlus />
        <div>세트 추가</div>
      </div>
    </div>
  );
};
